export const FETCH_TRIPS_INIT = "FETCH_TRIPS_INIT";
export const FETCH_TRIPS_SUCCESS = FETCH_TRIPS_INIT + "_SUCCESS";
export const FETCH_TRIPS_FAIL = FETCH_TRIPS_INIT + "_FAIL";

export const FETCH_TRIPDETAILSBYID_INIT = "FETCH_TRIPDETAILSBYID_INIT";
export const FETCH_TRIPDETAILSBYID_SUCCESS =
  FETCH_TRIPDETAILSBYID_INIT + "_SUCCESS";
export const FETCH_TRIPDETAILSBYID_FAIL = FETCH_TRIPDETAILSBYID_INIT + "_FAIL";

export const ADD_DOC_INIT = "ADD_DOC_INIT";

export const DELETE_DOC_INIT = "DELETE_DOC_INIT";

export const FETCH_COMPLETEDLOADDATA_INIT="FETCH_COMPLETEDLOADDATA_INIT";
export const FETCH_COMPLETEDLOADDATA_SUCCESS = FETCH_COMPLETEDLOADDATA_INIT+"_SUCCESS";
export const FETCH_COMPLETEDLOADDATA_FAIL = FETCH_COMPLETEDLOADDATA_INIT+"_FAIL";

export function fetchTrips(value) {
  return {
    type: FETCH_TRIPS_INIT,
    payload: value,
  };
}

export function fetchTripDetailById(value) {
  return {
    type: FETCH_TRIPDETAILSBYID_INIT,
    payload: value,
  };
}

export function addDocumentComp(value) {
  return {
    type: ADD_DOC_INIT,
    value: value,
  };
}

export function deleteDocument(value) {
  return {
    type: DELETE_DOC_INIT,
    value: value,
  };
}

export function fetchCompletedLoaddata(value) {
  return {
    type: FETCH_COMPLETEDLOADDATA_INIT,
    payload: value,
  };
}
